import { FC } from 'react';

interface Props {
  option: string;
  action: () => void;
  icon: React.ReactElement;
}

const MultiStageSearchOption: FC<Props> = ({ option, icon, action }) => {
  const handleButtonClick = () => {
    action();
  };

  return (
    <button
      className={`flex h-[4.875rem] mt-3 py-4 flex-col items-center flex-1 justify-center text-sm  lg:max-w-[7.72rem] w-full rounded-lg border ${'border-neutral-100'}`}
      type="button"
      onClick={handleButtonClick}
    >
      <div>{icon}</div>
      <div className="mt-2">{option}</div>
    </button>
  );
};

export default MultiStageSearchOption;
